import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { Resource } from '../../../../../core/models';
import { TemplateType, TransactionType, ResourceType } from '../../../../../core/enums';
import { ProcessNavigatorService } from '../../../../../core/services/process-navigator.service';
import { ProcessNavResourceDialogComponent } from '../process-nav-resource-dialog/process-nav-resource-dialog.component';

@Component({
  selector: 'kt-process-nav-view-dialog',
  templateUrl: './process-nav-view-dialog.component.html',
})
export class ProcessNavViewDialogComponent {
  ResourceType = ResourceType;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      templateType: TemplateType;
      templateName: string;
      transactionId: number;
      resources$: Observable<Resource[]>;
    },
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ProcessNavViewDialogComponent>,
    private processNavService: ProcessNavigatorService,
  ) {}

  close(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }

  getName(): string {
    return `${this.data.templateName} ${this.data.templateType.replace('_', ' ')}`.trim();
  }

  openResource(event: Event, resource: Resource): void {
    event.stopPropagation();

    this.processNavService
      .startResourceTracker(
        resource.id,
        this.data.transactionId,
        this.data.templateType === TemplateType.TASK_TEMPLATE
          ? TransactionType.TASK
          : TransactionType.WORKFLOW_QUEUE,
      )
      .pipe(
        take(1),
        map((res) => res.data.id),
      )
      .subscribe((trackerId) => {
        const resourceDialogRef = this.dialog.open(ProcessNavResourceDialogComponent, {
          width: '100vw',
          disableClose: true,
          closeOnNavigation: true,
          data: resource,
        });

        resourceDialogRef
          .afterClosed()
          .pipe(
            take(1),
            switchMap(() => this.processNavService.closeResourceTracker(resource.id, trackerId)),
          )
          .subscribe();
      });
  }
}
